import { usePageDrawer } from '@app/components/page/drawer/PageDrawerContext';
import { usePostHogCaptureLiveTopics } from './usePostHogCaptureLiveTopics';

/**
 * Returns a function that opens the screen drawer with the Live Topics panel.
 * Use the same drawer as create-fragment; opening this panel replaces the current drawer content.
 * Captures panel_opened for analytics when the drawer is opened.
 */
export function useOpenLiveTopicsDrawer(): () => void {
  const { openDrawer } = usePageDrawer();
  const capture = usePostHogCaptureLiveTopics();

  const openLiveTopicsDrawer = () => {
    capture('panel_opened');
    openDrawer('live-topics');
  };

  return openLiveTopicsDrawer;
}
